import React, { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { FaUpload } from 'react-icons/fa';

const SelectPrompt = ({ fileTypes, onUpdateFile = () => {}, onFileDrop = () => {} }) => {
  const inputRef = useRef(null);

  const openDialog = () => inputRef.current?.click();

  return (
    <div
      className="flex-fill align-self-stretch d-flex justify-content-center align-items-center"
      style={{
        border: '2px dashed var(--color-primary-shadow)',
        borderRadius: '8px',
        minHeight: '84px',
      }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={onFileDrop}
    >
      <div className="d-flex flex-column justify-content-center align-items-center text-center gap-1 py-2 px-3">
        <FaUpload size={20} className="text-muted" />
        <p className="mb-0 small text-muted">Drop file here or</p>
        <Button type="button" variant="light" size="sm" onClick={openDialog}>
          Select File
        </Button>
      </div>

      <input
        ref={inputRef}
        className="d-none"
        type="file"
        accept={fileTypes?.join(',')}
        onChange={onUpdateFile}
      />
    </div>
  );
};

export default SelectPrompt;
